import { render, staticRenderFns } from "./work-info.vue?vue&type=template&id=917ad61a&scoped=true&"
import script from "./work-info.vue?vue&type=script&lang=js&"
export * from "./work-info.vue?vue&type=script&lang=js&"
import style0 from "./work-info.vue?vue&type=style&index=0&id=917ad61a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917ad61a",
  null
  
)

export default component.exports